/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
//import { app } from '@/main';

// Boilerplate for generic mutations use in almost any module
import * as generic from '@/store/generic/mutations/result-status.js'
import { supportState } from '@/utils/student-support-session'

export function clearError (state, payload) {
  generic.clearError(state, payload)
}

export function setError (state, payload) {
  generic.setError(state, payload)
}

export function setSuccess (state, payload) {
  generic.setSuccess(state, payload)
}

export function setProcessing (state, payload) {
  generic.setProcessing(state, payload)
}

export function setNavMenuItems (state, payload) {
  const navMenuItems = JSON.parse(payload)
  state.navMenuItems = navMenuItems
}

export function setPermissions (state, payload) {
  const permissions = JSON.parse(payload)
  state.permissions = permissions
}

export function setToken (state, payload) {
  if (supportState.mode) return
  localStorage.setItem('token', payload)
  state.token = payload
}

export function setCurrentUser (state, payload) {
  if (supportState.mode) { if (supportState.active) state.currentUser = payload; return }
  localStorage.setItem('currentUser', JSON.stringify(payload))
  state.currentUser = payload
}

export function setLogoutStatus (state) {
  if (supportState.mode) { state.token = null; state.currentUser = null; return }
  localStorage.removeItem('token')
  localStorage.removeItem('currentUser')
  state.token = null
  state.currentUser = null
}

export function setCurrentEmailAndMobile (state, payload) {
  if (supportState.mode) return
  const currentUser = {...state.currentUser, updateInformation: true, email: payload.email, mobile: payload.mobile}
  localStorage.setItem('currentUser', JSON.stringify(currentUser))
  state.currentUser = currentUser
}

// /////////////////////////////////////////////
// COMPONENTS
// /////////////////////////////////////////////

// Vertical NavMenu

export function TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE (state, value) {
  state.isVerticalNavMenuActive = value
}

export function TOGGLE_REDUCE_BUTTON (state, val) {
  state.reduceButton = val
}

export function UPDATE_MAIN_LAYOUT_TYPE (state, val) {
  state.mainLayoutType = val
}

export function UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN (state, val) {
  state.verticalNavMenuItemsMin = val
}

export function UPDATE_VERTICAL_NAV_MENU_WIDTH (state, width) {
  state.verticalNavMenuWidth = width
}


// VxAutoSuggest
export function UPDATE_STARRED_PAGE (state, payload) {

  // find item index in search list state
  const index = state.navbarSearchAndPinList['pages'].data.findIndex((item) => item.url == payload.url)

  // update the main list
  state.navbarSearchAndPinList['pages'].data[index].is_bookmarked = payload.val

  // if val is true add it to starred else remove
  if (payload.val) {
    state.starredPages.push(state.navbarSearchAndPinList['pages'].data[index])
  } else {
    // find item index from starred pages
    const index = state.starredPages.findIndex((item) => item.url == payload.url)

    // remove item using index
    state.starredPages.splice(index, 1)
  }
}


// Navbar-Vertical

export function ARRANGE_STARRED_PAGES_LIMITED (state, list) {
  const starredPagesMore = state.starredPages.slice(10)
  state.starredPages     = list.concat(starredPagesMore)
}

export function ARRANGE_STARRED_PAGES_MORE (state, list) {
  let downToUp                 = false
  const lastItemInStarredLimited = state.starredPages[10]
  const starredPagesLimited    = state.starredPages.slice(0, 10)
  state.starredPages           = starredPagesLimited.concat(list)

  state.starredPages.slice(0, 10).map((i) => {
    if (list.indexOf(i) > -1) downToUp = true
  })

  if (!downToUp) {
    state.starredPages.splice(10, 0, lastItemInStarredLimited)
  }
}


// ////////////////////////////////////////////
// UI
// ////////////////////////////////////////////

export function TOGGLE_CONTENT_OVERLAY (state, val) {
  state.bodyOverlay = val
}

export function UPDATE_PRIMARY_COLOR (state, val) {
  state.themePrimaryColor = val
}

export function UPDATE_THEME (state, val) {
  state.theme = val
}

export function UPDATE_WINDOW_WIDTH (state, width) {
  state.windowWidth = width
}

export function UPDATE_WINDOW_SCROLL_Y (state, val) {
  state.scrollY = val
}


// /////////////////////////////////////////////
// User/Account
// /////////////////////////////////////////////

// Updates user info in state and localstorage

export function UPDATE_USER_INFO (state, payload) {

  // Get Data localStorage
  const userInfo = JSON.parse(localStorage.getItem('userInfo')) || state.AppActiveUser

  for (const property of Object.keys(payload)) {

    if (payload[property] != null) {
      // If some of user property is null - user default property defined in state.AppActiveUser
      state.AppActiveUser[property] = payload[property]

      // Update key in localStorage
      userInfo[property] = payload[property]
    }


  }
  // Store data in localStorage
  localStorage.setItem('userInfo', JSON.stringify(userInfo))
}

// export function changeLanguage(state, payload) {
//   app.$i18n.locale = payload;
//   localStorage.setItem('currentLanguage', payload)
//   state.currentLocale = payload
// }

// eslint-disable-next-line no-unused-vars
export function appCrash (state) {
  if (window.location.pathname !== '/app-crash') {
    window.location = '/app-crash'
  }
}
